{
 "about": [
  {
   "t": "h1",
   "text": "About Us"
  },
  {
   "t": "p",
   "text": "For our gospel did not come to you in word only, but also in power, and in the Holy Spirit and in much assurance, as you know what kind of men we were among you for your sake."
  },
  {
   "t": "p",
   "text": "1 Thessalonians 1:5"
  },
  {
   "t": "h2",
   "text": "Core Values"
  },
  {
   "t": "h3",
   "text": "Evangelism"
  },
  {
   "t": "p",
   "text": "Evangelism is the heart of LOLI \u2013 from stadium crusades to divine appointments one-on-one.\u00a0Nothing is more important than people encountering the Lord Jesus Christ!"
  },
  {
   "t": "p",
   "text": "Salvation, miracles, deliverance and being baptized with the fire of the Holy Spirit are the divine response to hungry hearts.\u00a0 There is power in the Name of Jesus!"
  },
  {
   "t": "h3",
   "text": "Compassion"
  },
  {
   "t": "p",
   "text": "Jesus loves people!\u00a0 Meeting the needs of the poor, hurting and forgotten is a huge part of the LOLI vision.\u00a0 From providing groceries and ice creams in remote villages to giving out teddy bears and big hugs to children in orphanages and hospitals, we are called to be the hands and feet of Jesus!"
  },
  {
   "t": "h3",
   "text": "Transformation"
  },
  {
   "t": "p",
   "text": "Prayer changes things!\u00a0 The prayer of Jesus was that we would be one even as He was one with the Father.\u00a0 Prayer, humility, unity, these things touch the heart of the Father.\u00a0 It is our desire to see lasting transformation in families, churches, communities \u2013 and even nations."
  },
  {
   "t": "h3",
   "text": "Destiny"
  },
  {
   "t": "p",
   "text": "Serving Jesus will change your life.\u00a0From working with the poor to serving in a large crusade, to connecting with other believers and participating in\u00a0Holy Spirit led team devotions\u00a0\u2013 you will not return home the same!"
  },
  {
   "t": "p",
   "text": "God has a destiny for your life.\u00a0 Our heart\u2019s desire is for you to grasp a bigger vision of who God is, and a larger understanding of what He can do in your life.\u00a0 There is nothing like life with Jesus!"
  },
  {
   "t": "h2",
   "text": "Meet The Team"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/stephen2.webp",
   "alt": ""
  },
  {
   "t": "h4",
   "text": "Stephen Evans"
  },
  {
   "t": "a",
   "text": "Stephen Evans",
   "href": "https://loli.org/team/stephen-evans/"
  },
  {
   "t": "a",
   "text": "Learn More",
   "href": "https://loli.org/team/stephen-evans/"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/PROFILE.webp",
   "alt": ""
  },
  {
   "t": "h4",
   "text": "Alisa Evans"
  },
  {
   "t": "a",
   "text": "Alisa Evans",
   "href": "https://loli.org/team/alisa-evans/"
  },
  {
   "t": "a",
   "text": "Learn More",
   "href": "https://loli.org/team/alisa-evans/"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/newsteve2.webp",
   "alt": ""
  },
  {
   "t": "h4",
   "text": "Steve New"
  },
  {
   "t": "a",
   "text": "Steve New",
   "href": "https://loli.org/team/steve-new/"
  },
  {
   "t": "a",
   "text": "Learn More",
   "href": "https://loli.org/team/steve-new/"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/stevenew-12.webp",
   "alt": ""
  },
  {
   "t": "h4",
   "text": "Dennis Aplicano"
  },
  {
   "t": "a",
   "text": "Dennis Aplicano",
   "href": "https://loli.org/team/dennis-aplicano/"
  },
  {
   "t": "a",
   "text": "Learn More",
   "href": "https://loli.org/team/dennis-aplicano/"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/AlvaroMatehuala.webp",
   "alt": ""
  },
  {
   "t": "h4",
   "text": "Alvaro Matehuala"
  },
  {
   "t": "a",
   "text": "Alvaro Matehuala",
   "href": "https://loli.org/team/alvaro-matehuala/"
  },
  {
   "t": "a",
   "text": "Learn More",
   "href": "https://loli.org/team/alvaro-matehuala/"
  },
  {
   "t": "h2",
   "text": "Our Story"
  },
  {
   "t": "h2",
   "text": "Serving with love"
  },
  {
   "t": "p",
   "text": "Light of Life International started in 2004, after Stephen and Alisa returned to Texas. Having served as the personal assistant to Reinhard Bonnke, Stephen had seen the Africa crusades first hand and had a fire burning in his heart to do the same. Surprisingly, the call came \u2013 not to Africa or places where Stephen and Alisa had contacts \u2013 but to Latin America. Growing into citywide evangelism certainly brought its challenges along the way, but 68 crusades later the Lord Jesus has demonstrated His great faithfulness and power over and over again"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/LOLI_Crusades_22-1024x768.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/LOLI_Events_19-1024x768.jpg",
   "alt": ""
  },
  {
   "t": "p",
   "text": "The journey has also been marked by encounters with children and families in poverty. As a teenager, Alisa had dreams of being surrounded by children on the mission field and Stephen served on his dad\u2019s church staff as the director of global missions. It should be no surprise then that LOLI seeks out creative ways to minister to the needs of people. From providing groceries and ice cream in remote and impoverished neighborhoods to giving huge teddy bears to children in hospitals and orphanages, compassion makes up a huge part of the LOLI vision. We are so thankful for the first 21 years of ministry in Honduras, Paraguay, Nicaragua, Dominican Republic, Costa Rica, Panama, El Salvador, Guatemala and Mexico. We are in awe of the power and love of Jesus Christ to save, heal, and transform lives. And as long as we can, we look forward to taking His Gospel even further!"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/10/our-story.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/LOLI_Events_19-1024x768.jpg",
   "alt": ""
  },
  {
   "t": "h2",
   "text": "Join Us"
  },
  {
   "t": "p",
   "text": "For more information on an upcoming trip, to join our team of global intercessors, or to receive more information about this ministry, please contact us."
  }
 ],
 "blog": [
  {
   "t": "h2",
   "text": "Blog"
  },
  {
   "t": "h5",
   "text": "If my people, who are called by my name, will humble themselves and pray and seek my face and turn from their wicked ways, then I will hear from heaven, and will forgive their sin and heal their land.\u201d"
  },
  {
   "t": "h5",
   "text": "2 Chronicles 7:14"
  },
  {
   "t": "h1",
   "text": "Blog"
  },
  {
   "t": "p",
   "text": "If my people, who are called by my name, will humble themselves and pray and seek my face and turn from their wicked ways, then I will hear from heaven, and will forgive their sin and heal their land.\u201d"
  },
  {
   "t": "p",
   "text": "2 Chronicles 7:14"
  },
  {
   "t": "h2",
   "text": "Latest Posts"
  }
 ],
 "contact-us": [
  {
   "t": "h2",
   "text": "404"
  },
  {
   "t": "h2",
   "text": "oops... Page not found"
  },
  {
   "t": "a",
   "text": "Return to Home",
   "href": "https://loli.org/"
  }
 ],
 "contact": [
  {
   "t": "h1",
   "text": "Contact"
  },
  {
   "t": "h2",
   "text": "But you shall receive power when the Holy Spirit has come upon you; and you shall be witnesses to Me\u2026\u201d Acts 1:8"
  },
  {
   "t": "h2",
   "text": "Serving with love"
  },
  {
   "t": "h2",
   "text": "LOLI ADDRESS"
  },
  {
   "t": "h2",
   "text": "PHONE NUMBER"
  },
  {
   "t": "h2",
   "text": "EMAIL"
  },
  {
   "t": "p",
   "text": "info@loli.org | prayer@loli.org"
  },
  {
   "t": "a",
   "text": "prayer@loli.org",
   "href": "mailto:prayer@loli.org"
  },
  {
   "t": "h2",
   "text": "Thank you for your interest in Light of Life International. If you would like more information on an upcoming trip, or join our team of global intercessors, or receive more information about this ministry, please contact us."
  },
  {
   "t": "h2",
   "text": "Get in Touch!"
  },
  {
   "t": "h2",
   "text": "Get in touch!"
  }
 ],
 "core-values": [
  {
   "t": "h2",
   "text": "core values"
  },
  {
   "t": "h5",
   "text": "If my people, who are called by my name, will humble themselves and pray and seek my face and turn from their wicked ways, then I will hear from heaven, and will forgive their sin and heal their land.\u201d"
  },
  {
   "t": "h5",
   "text": "2 Chronicles 7:14"
  },
  {
   "t": "h2",
   "text": "CORE VALUES"
  },
  {
   "t": "h2",
   "text": "EVANGELISM"
  },
  {
   "t": "p",
   "text": "Evangelism is the heart of LOLI \u2013 from stadium crusades to divine appointments one-on-one.\u00a0Nothing is more important than people encountering the Lord Jesus Christ!"
  },
  {
   "t": "p",
   "text": "Salvation, miracles, deliverance and being baptized with the fire of the Holy Spirit are the divine response to hungry hearts.\u00a0 There is power in the Name of Jesus!"
  },
  {
   "t": "h2",
   "text": "COMPASSION"
  },
  {
   "t": "p",
   "text": "Jesus loves people!\u00a0 Meeting the needs of the poor, hurting and forgotten is a huge part of the LOLI vision.\u00a0 From providing groceries and ice creams in remote villages to giving out teddy bears and big hugs to children in orphanages and hospitals, we are called to be the hands and feet of Jesus!"
  },
  {
   "t": "h2",
   "text": "TRANSFORMATION"
  },
  {
   "t": "p",
   "text": "Prayer changes things!\u00a0 The prayer of Jesus was that we would be one even as He was one with the Father.\u00a0 Prayer, humility, unity, these things touch the heart of the Father.\u00a0 It is our desire to see lasting transformation in families, churches, communities \u2013 and even nations."
  },
  {
   "t": "h2",
   "text": "DESTINY"
  },
  {
   "t": "p",
   "text": "Serving Jesus will change your life.\u00a0From working with the poor to serving in a large crusade, to connecting with other believers and participating in\u00a0Holy Spirit led team devotions\u00a0\u2013 you will not return home the same!"
  },
  {
   "t": "p",
   "text": "God has a destiny for your life.\u00a0 Our heart\u2019s desire is for you to grasp a bigger vision of who God is, and a larger understanding of what He can do in your life.\u00a0 There is nothing like life with Jesus!"
  }
 ],
 "crusade__tarija-bolivia": [
  {
   "t": "h1",
   "text": "Tarija"
  },
  {
   "t": "a",
   "text": "Home",
   "href": "https://loli.org"
  },
  {
   "t": "a",
   "text": "Crusade",
   "href": "https://loli.org/crusade/"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/09/crusades-loop-background-updated-1024x512.jpg",
   "alt": ""
  },
  {
   "t": "h2",
   "text": "Tarija"
  },
  {
   "t": "a",
   "text": "Sign up to go",
   "href": "/join-us#jointeam"
  }
 ],
 "donate": [
  {
   "t": "h1",
   "text": "Donate"
  },
  {
   "t": "p",
   "text": "They desired only that we should remember the poor, the very thing which I also was eager to do."
  },
  {
   "t": "p",
   "text": "Galations 2:10"
  },
  {
   "t": "h2",
   "text": "Donate"
  },
  {
   "t": "p",
   "text": "Thank you for your interest in Light of Life International. your tax deductible (for USA residents) gift makes it possible for this ministry to offer the hope and salvation found in Jesus Christ to the lost and hurting in Latin America and Africa. Thank you!"
  },
  {
   "t": "h2",
   "text": "THERE ARE THREE SIMPLE WAYS YOU CAN  CONTRIBUTE TO LOLI MINISTRIES"
  },
  {
   "t": "h2",
   "text": "Mail your tax deductible donation to:"
  },
  {
   "t": "p",
   "text": "Light of Life International 4364 Western Center Blvd #124 Fort Worth, Texas 76137"
  },
  {
   "t": "h2",
   "text": "Make your tax deductible donation online by clicking the donate button below."
  },
  {
   "t": "h2",
   "text": "Make your tax deductible donation online by scanning the QR code below."
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/zelle.png",
   "alt": ""
  },
  {
   "t": "h2",
   "text": "Join Us"
  },
  {
   "t": "p",
   "text": "Thank you for your interest in Light of Life International. If you would like more information on an upcoming trip, or join our team of global intercessors, or receive more information about this ministry, please contact us."
  },
  {
   "t": "a",
   "text": "Contact us",
   "href": "https://loli.org/contact/"
  }
 ],
 "donation-form": [
  {
   "t": "h1",
   "text": "Donation Form"
  },
  {
   "t": "h5",
   "text": "They desired only that we should remember the poor, the very thing which I also was eager to do."
  },
  {
   "t": "h5",
   "text": "Galations 2:10"
  },
  {
   "t": "h2",
   "text": "Donate Now"
  },
  {
   "t": "a",
   "text": "One-time Payment",
   "href": "https://loli.org/donation-form/"
  },
  {
   "t": "a",
   "text": "Monthly Recurring",
   "href": "https://loli.org/donation-form/monthly-recurring/"
  },
  {
   "t": "h3",
   "text": "One-Time Payment"
  }
 ],
 "donation-form__monthly-recurring": [
  {
   "t": "h1",
   "text": "Monthly Recurring"
  },
  {
   "t": "h5",
   "text": "They desired only that we should remember the poor, the very thing which I also was eager to do."
  },
  {
   "t": "h5",
   "text": "Galations 2:10"
  },
  {
   "t": "h2",
   "text": "Donate Now"
  },
  {
   "t": "a",
   "text": "One-time Payment",
   "href": "https://loli.org/donation-form/"
  },
  {
   "t": "a",
   "text": "Monthly Recurring",
   "href": "https://loli.org/donation-form/monthly-recurring/"
  },
  {
   "t": "h3",
   "text": "Monthly Recurring Payment"
  }
 ],
 "fire-carriers": [
  {
   "t": "h1",
   "text": "Fire Carriers"
  },
  {
   "t": "h3",
   "text": "You Shall Receive Power!"
  },
  {
   "t": "p",
   "text": "What happens when average people dare to dream with an extraordinary God?"
  },
  {
   "t": "h2",
   "text": "You Shall Receive Power!"
  },
  {
   "t": "h4",
   "text": "What happens when average people dare to dream with an extraordinary God?"
  },
  {
   "t": "p",
   "text": "\u201cStephen Evans is an example of humility and full of passion for souls. I have known him in difficult times in our country and his dedication and love for the lost has always been his mission. He does not seek his own glory nor does he put a price on his mes-sage, his only objective is to snatch souls to Heaven, and to exalt the powerful Name of Jesus.\u201d"
  },
  {
   "t": "p",
   "text": "\u201cStephen Evans is a personal friend. I admire him for his love and passion for souls. I\u2019ve had the opportunity to go along with him on several events and there are two things I\u2019m surprised about: (1) First is the way he calls together the nations through pastors. He inspires them to grow the church, while strongly investing in them as well. (2) Second are the large evangelistic gatherings that are celebrated in nations. This is an evidence of a divine mantle over his life. I bless his work in this and in future times.\u201d"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/FC_transparent_3D_large-218x300-1.webp",
   "alt": ""
  },
  {
   "t": "a",
   "text": "BUY NOW",
   "href": "#getcopy"
  },
  {
   "t": "h2",
   "text": "Grab a Copy!"
  }
 ],
 "fire-starters-and-rain-crusaders": [
  {
   "t": "h1",
   "text": "Fire Starters and Rain Crusaders"
  },
  {
   "t": "p",
   "text": "\u201cTell him what you have seen and heard \u2013 the blind see, the lame walk, the lepers are cured, the deaf hear, the dead are raised to life and the Good News is being preached to the poor.\u201d \u2013 Luke 7.22"
  },
  {
   "t": "h2",
   "text": "About The Book"
  },
  {
   "t": "p",
   "text": "There is a fire inside of you. A Holy Spirit flame ready to ignite and push you out of the ordinary and routine. One that will launch you into a life of bold faith and open doors. It is a place where nothing is impossible and miracles are real. It is a life of fire, destiny and supernatural impact."
  },
  {
   "t": "p",
   "text": "In Fire Starters and Rain Crusaders, Stephen Evans chronicles a ten year journey of faith where believing for the impossible leads to God revealing himself in extraordinary ways."
  },
  {
   "t": "p",
   "text": "You can be the next game changer, nation shaker, and history maker. It is not about the people you know, what you have, or how qualified you are. It is a passion for Jesus, an unquenchable cry to live for Him, and a boldness to dream with God for the impossible."
  },
  {
   "t": "p",
   "text": "Fire Starters and Rain Crusaders will encourage you to truly dream beyond your own comprehension where only God can fulfill your dreams."
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/FSRC_3D_transparent-250x300-1.webp",
   "alt": ""
  },
  {
   "t": "a",
   "text": "BUY NOW",
   "href": "#getcopy"
  },
  {
   "t": "h2",
   "text": "Grab a Copy!"
  },
  {
   "t": "h2",
   "text": "A fire was started, that no rain can quench."
  },
  {
   "t": "p",
   "text": "\u201cI have known men of great faith doing great things and I have known men of great humility carrying the fragrance of Christ, but rarely have I known a man like Stephen Evans who walks with both great faith and great humility. By faith, Stephen\u2019s ministry leaves a lasting impact in the nations, and his humility leaves a sweet taste with the churches and the authorities of the cities. Fire Starters and Rain Crusaders will inspire you to believe God for great things and to love people in the little things.\u201d"
  },
  {
   "t": "p",
   "text": "\u201cStephen Evans is a personal friend. I admire him for his love and passion for souls. I\u2019ve had the opportunity to go along with him on several events and there are 2 things I\u2019m surprised about: 1) the way he calls together the nations through pastors. He inspires them to grow the church, while strongly investing in them as well and 2) the large evangelistic gatherings that are celebrated in nations. This is an evidence of a divine mantle over his life. I bless his work in this and in future times.\u201d"
  },
  {
   "t": "p",
   "text": "\u201cI\u2019ve had the joy of knowing Stephen and his family for many years. He has an incredible legacy and calling, and he\u2019s a man who hears the voice of the Spirit and acts in response with amazing faith. These stories will inspire you to a deeper, bolder walk with God and challenge you to display strength and take action.\u201d"
  },
  {
   "t": "p",
   "text": "\u201cStephen Evans was for a short time part of my team. I am glad to say that fire of Holy Spirit Evangelism, in something like an electric arc, leaped on him and turned him into a firebrand preacher. I have followed his reports ever since and recommend this book heartedly.\u201d"
  }
 ],
 "home": [
  {
   "t": "h1",
   "text": "Tarija bolivia"
  },
  {
   "t": "h2",
   "text": "October 18 \u2013 26, 2026"
  },
  {
   "t": "h2",
   "text": "Our Core Values"
  },
  {
   "t": "h3",
   "text": "Passion For Souls"
  },
  {
   "t": "h3",
   "text": "Compassion For The Poor"
  },
  {
   "t": "h3",
   "text": "Transformation By Unity & Prayer"
  },
  {
   "t": "h3",
   "text": "Destiny"
  },
  {
   "t": "a",
   "text": "Learn More",
   "href": "https://loli.org/about/"
  },
  {
   "t": "h2",
   "text": "Who We Are"
  },
  {
   "t": "p",
   "text": "Light of Life International is an evangelistic and compassionate ministry reaching Latin America and Africa. For over 21 years, the Holy Spirit has led us into hospitals, orphanages, public schools, as well as soccer stadiums and city plazas to proclaim the Good News that Jesus saves."
  },
  {
   "t": "h1",
   "text": "Our Upcoming Crusades"
  },
  {
   "t": "h2",
   "text": "Tarija"
  },
  {
   "t": "h2",
   "text": "bolivia"
  },
  {
   "t": "a",
   "text": "Sign Up",
   "href": "/join-us/#jointeam"
  },
  {
   "t": "h2",
   "text": "Past Crusades"
  },
  {
   "t": "h2",
   "text": "Willemstad, Cura\u00e7ao"
  },
  {
   "t": "h2",
   "text": "La Entrada, Honduras"
  },
  {
   "t": "h2",
   "text": "Paramaribo, Suriname"
  },
  {
   "t": "h2",
   "text": "Saint-Laurent, French Guiana"
  },
  {
   "t": "h2",
   "text": "Georgetown, Guyana"
  },
  {
   "t": "h2",
   "text": "Qacha's Nek, Lesotho"
  },
  {
   "t": "a",
   "text": "See More",
   "href": "/crusades/"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/Daystar1-1-1024x449.jpg",
   "alt": ""
  },
  {
   "t": "h2",
   "text": "God has a beautiful destiny for everyone, and that includes you."
  },
  {
   "t": "h2",
   "text": "You Shall Receive Power! What Happens When Average People Dare\nTo Dream with an Extraordinary God?"
  },
  {
   "t": "a",
   "text": "Order Now",
   "href": "https://loli.org/fire-carriers/"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/FC_transparent_3D_large-218x300-1.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/FSRC_3D_transparent-250x300-1.webp",
   "alt": ""
  },
  {
   "t": "h2",
   "text": "Read more about the crusades, miracles, and testimonies of Light of Life International."
  },
  {
   "t": "p",
   "text": "Pick up your copy today!"
  },
  {
   "t": "a",
   "text": "Order Now",
   "href": "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=KEPANMHB96ZXS"
  },
  {
   "t": "a",
   "text": "Learn more",
   "href": "https://loli.org/fire-starters-and-rain-crusaders/"
  },
  {
   "t": "h2",
   "text": "Serving with love"
  },
  {
   "t": "h2",
   "text": "Take a look at what the Lord Jesus has done across Latin America and Africa!"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/Home_JoinUs-1.webp",
   "alt": ""
  },
  {
   "t": "h2",
   "text": "Lastest Blog Posts"
  },
  {
   "t": "a",
   "text": "View More Posts",
   "href": "https://loli.org/blog/"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm08.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm07.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm06.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm05.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm04.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm03.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm02.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm01.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm01.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm02.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm03.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm04.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm05.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm06.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm07.webp",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vm08.webp",
   "alt": ""
  }
 ],
 "join-us": [
  {
   "t": "h1",
   "text": "Join Us"
  },
  {
   "t": "p",
   "text": "Join other missionaries for a week of eternal importance\u2026 you will never forget!"
  },
  {
   "t": "h2",
   "text": "Share the love of Jesus\nin"
  },
  {
   "t": "h2",
   "text": "Tarija"
  },
  {
   "t": "h2",
   "text": "bolivia"
  },
  {
   "t": "a",
   "text": "Sign Up",
   "href": "/join-us/#jointeam"
  },
  {
   "t": "a",
   "text": "Join the team",
   "href": "#jointeam"
  },
  {
   "t": "h2",
   "text": "Share the love & compassion of Jesus in evangelism"
  },
  {
   "t": "h2",
   "text": "Give food through daily distribution to the poor"
  },
  {
   "t": "h2",
   "text": "Experience the power of God in crusade ministry"
  },
  {
   "t": "h2",
   "text": "Touch the lives of children in orphanages"
  },
  {
   "t": "h2",
   "text": "Impact and transform nations and cities across the world"
  },
  {
   "t": "h2",
   "text": "Share the love of Jesus"
  },
  {
   "t": "h2",
   "text": "Share the love & compassion of Jesus in evangelism"
  },
  {
   "t": "h2",
   "text": "Give food through daily distribution to the poor"
  },
  {
   "t": "h2",
   "text": "Experience the power of God in crusade ministry"
  },
  {
   "t": "h2",
   "text": "Touch the lives of children in orphanages"
  },
  {
   "t": "h2",
   "text": "Impact and transform nations and cities across the world"
  },
  {
   "t": "h2",
   "text": "Join the team"
  },
  {
   "t": "p",
   "text": "*If you do not yet have a passport, this information can be provided to LOLI at a later date."
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/plugins/formidable/images/ajax_loader.gif",
   "alt": "Sending"
  },
  {
   "t": "h2",
   "text": "Join the Light of Life International Prayer Network"
  },
  {
   "t": "p",
   "text": "Thank you for your prayers and interest in Light of Life International. If you are interested in joining our team of global intercessors or receiving more information about this ministry, please contact us. God bless you!"
  },
  {
   "t": "a",
   "text": "Connect with us",
   "href": "https://loli.org/contact/"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_07-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_06-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_05-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_04-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_03-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_02-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_01-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_01-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_02-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_03-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_04-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_05-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_06-1.jpg",
   "alt": ""
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/vol_07-1.jpg",
   "alt": ""
  }
 ],
 "privacy-policy": [
  {
   "t": "h1",
   "text": "Privacy Policy"
  },
  {
   "t": "h2",
   "text": "Who we are"
  },
  {
   "t": "p",
   "text": "Our website address is: https://loli.org ."
  },
  {
   "t": "a",
   "text": "https://loli.org",
   "href": "https://loli.org"
  },
  {
   "t": "h2",
   "text": "Comments"
  },
  {
   "t": "p",
   "text": "When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor\u2019s IP address and browser user agent string to help spam detection."
  },
  {
   "t": "p",
   "text": "An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. The Gravatar service privacy policy is available here: https://automattic.com/privacy/. After approval of your comment, your profile picture is visible to the public in the context of your comment."
  },
  {
   "t": "h2",
   "text": "Media"
  },
  {
   "t": "p",
   "text": "If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website."
  },
  {
   "t": "h2",
   "text": "Cookies"
  },
  {
   "t": "p",
   "text": "If you leave a comment on our site you may opt-in to saving your name, email address and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year."
  },
  {
   "t": "p",
   "text": "If you visit our login page, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser."
  },
  {
   "t": "p",
   "text": "When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select \u201cRemember Me\u201d, your login will persist for two weeks. If you log out of your account, the login cookies will be removed."
  },
  {
   "t": "p",
   "text": "If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day."
  },
  {
   "t": "h2",
   "text": "Embedded content from other websites"
  },
  {
   "t": "p",
   "text": "Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website."
  },
  {
   "t": "p",
   "text": "These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website."
  },
  {
   "t": "h2",
   "text": "Who we share your data with"
  },
  {
   "t": "p",
   "text": "If you request a password reset, your IP address will be included in the reset email."
  },
  {
   "t": "h2",
   "text": "How long we retain your data"
  },
  {
   "t": "p",
   "text": "If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue."
  },
  {
   "t": "p",
   "text": "For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information."
  },
  {
   "t": "h2",
   "text": "What rights you have over your data"
  },
  {
   "t": "p",
   "text": "If you have an account on this site, or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes."
  },
  {
   "t": "h2",
   "text": "Where we send your data"
  },
  {
   "t": "p",
   "text": "Visitor comments may be checked through an automated spam detection service."
  }
 ],
 "team__alisa-evans": [
  {
   "t": "h1",
   "text": "Alisa Evans"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/PROFILE.webp",
   "alt": ""
  },
  {
   "t": "p",
   "text": "Alisa was part of the LOLI family before there even was one! When Stephen was invited to serve with Evangelist Reinhard Bonnke, she saw it as a divine door to something extraordinary. She was right! 21 years later and many nations later, Alisa continues to balance family and ministry. Stephen and Alisa have been married 25 years and have two children."
  },
  {
   "t": "a",
   "text": "Back to Team",
   "href": "https://loli.org/about/#team"
  }
 ],
 "team__alvaro-matehuala": [
  {
   "t": "h1",
   "text": "Alvaro Matehuala"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/AlvaroMatehuala.webp",
   "alt": ""
  },
  {
   "t": "p",
   "text": "Alvaro has been part of the LOLI family since 2012, when he attended the Honduras Prays national campaign in San Pedro Sula. Two years later he started traveling with Stephen and speaking at the LOLI prayer and pastor conferences. In 2016, he joined the staff as Director of Intercession. Alvaro is married to Linda, has five children, six grandchildren, and also serves as President of Christian International House of Prayer."
  },
  {
   "t": "a",
   "text": "Back to Team",
   "href": "https://loli.org/about/#team"
  }
 ],
 "team__dennis-aplicano": [
  {
   "t": "h1",
   "text": "Dennis Aplicano"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/stevenew-12.webp",
   "alt": ""
  },
  {
   "t": "p",
   "text": "Dennis has been part of the LOLI\u00a0family from the beginning. He met Stephen in 2004. The more they talked and dreamed about the nations, the more they sensed the Lord drawing them together to win souls and minister to the hurting in Latin America."
  },
  {
   "t": "p",
   "text": "In November 2005, Dennis and Stephen stood side by side in Tela, Honduras for the first LOLI crusade.\u00a0Dozens of crusades later,\u00a0Dennis\u00a0continues to serve as crusade director, lead translator, and a vital part of the\u00a0LOLI\u00a0team.\u00a0Dennis is married to Tammy, has three children and lives in San Pedro Sula."
  },
  {
   "t": "a",
   "text": "Back to Team",
   "href": "https://loli.org/about/#team"
  }
 ],
 "team__stephen-evans": [
  {
   "t": "h1",
   "text": "Stephen Evans"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/stephen2.webp",
   "alt": ""
  },
  {
   "t": "p",
   "text": "Stephen was born in Australia and grew up in Texas.\u00a0 Traveling with his dad, Desmond Evans around the world, stimulated the desire inside his heart for missions.\u00a0 In 2004 he joined Evangelist Reinhard Bonnke as his personal assistant.\u00a0 The Holy Spirit used this time to sharpen the faith of Stephen and Alisa, and expand their vision for city-wide evangelism and national transformation."
  },
  {
   "t": "a",
   "text": "Desmond Evans",
   "href": "http://desevans.com/"
  },
  {
   "t": "p",
   "text": "As founder and president of Light of Life International, Stephen and his LOLI team have conducted over 61 crusades in over 19 countries \u2013 and are believing for many more!"
  },
  {
   "t": "a",
   "text": "Back to Team",
   "href": "https://loli.org/about/#team"
  }
 ],
 "team__steve-new": [
  {
   "t": "h1",
   "text": "Steve New"
  },
  {
   "t": "img",
   "src": "https://loli.org/wp-content/uploads/2025/08/newsteve2.webp",
   "alt": ""
  },
  {
   "t": "p",
   "text": "Steve has been part of the LOLI\u00a0family from the beginning. He met Stephen and Alisa in 2004 when they returned from serving\u00a0Reinhard Bonnke. In 2005,\u00a0Steve and Stephen\u00a0grew closer during a mission trip to Medellin, Colombia \u2013 and Steve agreed to join LOLI in Tela for the first crusade \u2013 a month later. The rest is history!"
  },
  {
   "t": "p",
   "text": "A graduate of Texas A&M, Steve serves as the VP of LOLI and travels frequently with Stephen. Steve is available as a speaker, and lives in Fort Worth with his wife, Yvette. He has three children and five grandchildren."
  },
  {
   "t": "a",
   "text": "Back to Team",
   "href": "https://loli.org/about/#team"
  }
 ],
 "thank-you": [
  {
   "t": "h2",
   "text": "Thank you"
  },
  {
   "t": "p",
   "text": "Your responses were successfully submitted."
  },
  {
   "t": "a",
   "text": "Return to Home",
   "href": "https://loli.org/"
  }
 ]
}